function percentageValidator({ input, msgs, params }) {
  const min = (params && params.min) || 0;
  const max = (params && params.max) || 100;

  if (parseFloat(input) < parseFloat(min)) {
    if (msgs && msgs.min) {
      return msgs.min.replace('%s', input).replace('%s', min);
    }
    return `Must be greater than ${min}`;
  }
  if (parseFloat(input) > parseFloat(max)) {
    if (msgs && msgs.max) {
      return msgs.max.replace('%s', input).replace('%s', max);
    }
    return `Must be less than ${max}`;
  }

  return null;
}

export default percentageValidator;
